import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { API_GATEWAY_CONFIG } from '../config/apiGatewayConfig';
import { setGlobalTokenGetter } from '../config/apiRouting';
import { initializeGlobalFetchOverride } from '../utils/globalFetchOverride';

/**
 * Component that initializes the API Gateway configuration with proper authentication
 * This connects the Cognito AuthContext to the API Gateway migration utility
 */
const ApiGatewayInitializer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { getIdToken, isAuthenticated, session } = useAuth();

  useEffect(() => {
    API_GATEWAY_CONFIG.setTokenGetter(getIdToken);
    setGlobalTokenGetter(getIdToken);
    initializeGlobalFetchOverride();
  }, [getIdToken, isAuthenticated, session]);

  return <>{children}</>;
};

export default ApiGatewayInitializer;